export default __webpack_public_path__ + "static/media/man-using-stylus-pen-for-touching-the-digital-tablet-screen-6335.df8b9082.jpg";